__turbopack_context__.v({
  "container": "SubmenuItem-module__4SeiJa__container",
  "icon": "SubmenuItem-module__4SeiJa__icon",
  "selected": "SubmenuItem-module__4SeiJa__selected",
});
